'use client'

import { useEffect } from 'react'
import { fireCallConversion } from '@/lib/gtag-conversions'

/**
 * Fires the Google Ads "Click to call" conversion on every tel: link click.
 *
 * Uses document-level capture-phase delegation so it works with Nimbata DNI:
 * Nimbata replaces both the visible number and the href on tel: anchors after
 * page load. By listening in the capture phase at the document level, we catch
 * the click after Nimbata has already done its swap.
 */
let listenerSetup = false

function setupGlobalListener() {
  if (listenerSetup) return
  listenerSetup = true

  document.addEventListener(
    'click',
    (e) => {
      const anchor = (e.target as HTMLElement).closest(
        'a[href^="tel:"]',
      ) as HTMLAnchorElement | null
      if (anchor) fireCallConversion()
    },
    { capture: true },
  )
}

export default function PhoneConversionTracker() {
  useEffect(() => {
    setupGlobalListener()
  }, [])

  return null
}
